/*eslint-disable */

import { bus } from '@/main';
import { mapGetters } from 'vuex';
import removeQBankPopup from '../q-ans-remove-popup/';

export default {
  name: 'q-ans-list',
  components: {
    'remove-q-bank-popup' : removeQBankPopup
  },
  props: [],
  data () {
    return {
      qBankQansListData:null,
      qBankQansListRslts:[],
      removeQuePopupState:false,
      removeQueId:'',
      qBankInfo:null,
      qBankName:'',
      apiLoaderForQbanks:false
    }
  },
  computed: {
    ...mapGetters([
      'getQAnsListWithOptionGetter',
    ]),
    getCandidateListFun(){
     this.qBankQansListData = this.$store.getters.getQAnsListWithOptionGetter.data
     return 
    },
    setInintialState(){
      if(this.qBankQansListData){
        this.qBankQansListRslts = this.qBankQansListData.results;
      }
      return;
    }
  },
  mounted () {
    this.getQbankInfoByIdMethod();
    this.getCandidateListFun;
    this.setInintialState;
    bus.$on('removeQuePopupStateBus', (data) => {
      this.removeQuePopupState = data
    })
  },
  methods: {
    getQbankInfoByIdMethod(){
      this.apiLoaderForQbanks = true
      this.$store.dispatch('getQBankInfoByIdAction', {id:this.$route.params.qbankId}).then((res) => {
        this.qBankInfo = res.data.data.results
        this.qBankName = this.qBankInfo.name
        this.apiLoaderForQbanks = false
      })
    },
    removeQueInfoMethod(id){
      this.removeQueId = id
      this.removeQuePopupState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch: {
    getCandidateListFun(){
      return this.$store.getters.getQAnsListWithOptionGetter; 
    },
    setInintialState(){
      if(this.qBankQansListData){
        this.qBankQansListRslts = this.qBankQansListData.results;
      }
      return;
    }
  },
}